import lazyVideoHelper from "../../../../../../components/bhg/lazyVideos-helper";

(() => {
  const BRHMultimedia = () => {
    const selectors = {
      component: "brh-video",
    };

    const init = () => {
      const parentElement = Array.from(document.getElementsByClassName(selectors.component));
      if (parentElement) {
        parentElement.forEach((element) => {
          const body = document.querySelector("body");
          const videoButton = element.querySelector(".js-open-video");
          const modal = document.querySelector(".brh-modal");
          const modalSection = modal.querySelector(".js-brh-modal-section");
          const modalContainer = modal.querySelector(".brh-modal-container");
          const modalContent = modal.querySelector(".brh-modal-content");
          const modalCloseButton = modal.querySelector(".js-btn-close");

          const clonedVideoPlayer = element.querySelector(".js-video-player");

          if (videoButton) {
            videoButton.addEventListener("click", () => {
              body.classList.add("mod--menu-open");

              if (clonedVideoPlayer) {
                modal.style.display = "block";
                modalSection.style.display = "block";
                modalContent.style.backgroundColor = "transparent";
                clonedVideoPlayer.style.display = "block";
                modalCloseButton.classList.add("mod--mask-white");
                modalContainer.appendChild(clonedVideoPlayer);

                lazyVideoHelper.modalCheckEnableVideo(clonedVideoPlayer.querySelector(".video-generic"));
              }
            });
            if (modalCloseButton) {
              modalCloseButton.addEventListener("click", () => {
                body.classList.remove("mod--menu-open");

                if (clonedVideoPlayer) {
                  clonedVideoPlayer.querySelector("video").pause();
                  clonedVideoPlayer.style.display = "none";
                }
                modal.style.display = "none";
                modalSection.style.display = "none";
                modalContent.style.backgroundColor = "white";
                modalCloseButton.classList.remove("mod--mask-white");
                modalContainer.innerHTML = "";
              });
            }
          }
        });
      }
    };
    init();
  };
  document.addEventListener("DOMContentLoaded", BRHMultimedia);
})();
